export interface SkillProps {
    name: string;
    icon?: string;
}

const Skill = ({ name, icon }: SkillProps) => {
    return (
        <span className="skill-pill">
            {icon && <i className={icon} aria-hidden="true" />}
            <span className="skill-pill-name">{name}</span>
        </span>
    );
};

export default Skill;
